import React, {useEffect,useRef} from 'react';
export default function SalesIntelligencePage(){
 const host=useRef(null);
 useEffect(()=>{
  let cancelled=false;
  const root=host.current.shadowRoot||host.current.attachShadow({mode:'open'});
  root.innerHTML='<link rel="stylesheet" href="/sales-ui/style.css"><div class="embedded"><div id="app">Satış fırsatları yükleniyor…</div><dialog id="dialog"></dialog></div>';
  import(/* webpackIgnore: true */ '/sales-ui/app.js').then(m=>{if(!cancelled)m.mountSales(root,true);}).catch(()=>{if(!cancelled)root.querySelector('#app').textContent='Satış modülü yüklenemedi. Sayfayı yenileyin.';});
  return ()=>{cancelled=true;};
 },[]);
 return <div ref={host}/>;
}
